import { Routes } from '@angular/router';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    loadComponent: () =>
      import('@softline/application').then((o) => o.SettingsComponent),
  },
];
